import {
  MERCHANT_DASHBOARD_PERCURRENCY_SUCCESS,
  MERCHANT_DASHBOARD_PERCURRENCY_FAILED,
  RESET_MERCHANT_DASHBOARD_PERCURRENCY,
  LOADING_MERCHANT_DASHBOARD_PERCURRENCY,
  NETWORK_ERROR_MERCHANT_DASHBOARD_PERCURRENCY,
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  success: false,
  data: {},
  networkError: "",
  invalidRequest: false,
  description: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_MERCHANT_DASHBOARD_PERCURRENCY: {
      return {
        ...state,
        isLoading: true,
        failed: false,
        success: false,
        invalidRequest: false,
        data: action.payload,
        description: "",
      };
    }
    case MERCHANT_DASHBOARD_PERCURRENCY_FAILED: {
      return {
        ...state,
        isLoading: false,
        failed: true,
        success: false,
        invalidRequest: false,
        data: action.payload,
        description: "",
      };
    }
    case MERCHANT_DASHBOARD_PERCURRENCY_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: true,
        invalidRequest: false,
        data: action.payload,
        description: "",
      };
    }
    case NETWORK_ERROR_MERCHANT_DASHBOARD_PERCURRENCY: {
      return {
        ...state,
        isLoading: false,
        failed: true,
        success: false,
        invalidRequest: true,
        data: action.payload,
        description: "",
      };
    }
    case RESET_MERCHANT_DASHBOARD_PERCURRENCY: {
      return (state = initialState);
    }

    default:
      return state;
  }
};
